<script>
	import { isItBedRockShutDownTime, isItBedrockTime } from '../util';
</script>

{#if isItBedRockShutDownTime()}
	<div class="sm:absolute w-full sm:bg-fx-grey-800 h-full bg-opacity-90 p-4">
		<div class="flex flex-col items-center gap-4">
			<div class="flex gap-2">
				<img src="info_grey.png" alt="info" class="w-5 h-5" />
				<div class="text-lg text-fx-yellow font-medium">Important Update</div>
			</div>
			<div class="text-sm text-fx-grey-300 text-center">
				Please be informed that our website will experience scheduled downtime due to the <span
					class="font-semibold">Optimism Bedrock</span
				>
				upgrade. The downtime will commence at
				<span class="whitespace-nowrap font-semibold">16:00 UTC</span>
				on the 6th of June, 2023, and is expected to last approximately 6 hours while the upgrade is
				carried out. As a result, Polynomial will temporarily restrict certain functionalities, including
				the ability to add or remove margin and open or close positions until the update is completed.
				Thank you for understanding.

				<a
					class="text-fx-pink font-medium ml-1"
					href="https://mirror.xyz/0xf3897707d8Fa5dC27b2A6575319e409a464eB8D8/JLkxR6F6EIdAjqmcHMIDatr0w24OM-SoF3cvZcfPTBU"
					target="_blank">Read more</a
				>
			</div>
		</div>
	</div>
{:else}
	<div class="sm:absolute w-full sm:bg-fx-grey-800 h-full bg-opacity-90 p-4">
		<div class="flex flex-col items-center gap-4">
			<div class="flex gap-2">
				<img src="info_grey.png" alt="info" class="w-5 h-5" />
				<div class="text-lg text-fx-yellow font-medium">Important Update</div>
			</div>
			<div class="text-sm text-fx-grey-300 text-center">
				Due to
				<span class="font-semibold">Optimism Bedrock</span>
				upgrade, Polynomial trade will be running in close-only mode from
				<span class="whitespace-nowrap font-semibold">16:00 UTC 4th June, 2023</span>
				to <span class="whitespace-nowrap font-semibold">16:00 UTC 6th June, 2023.</span> During
				this time, you can add margin, remove margin or close your open positions form the Positions
				tab.
				<br />There will be a complete downtime starting at
				<span class="whitespace-nowrap font-semibold">16:00 UTC</span>
				on
				<span class="whitespace-nowrap font-semibold">6th June, 2023</span>
				for approximately 6 hours during the upgrade.
				<a
					class="text-fx-pink font-medium ml-1"
					href="https://mirror.xyz/0xf3897707d8Fa5dC27b2A6575319e409a464eB8D8/JLkxR6F6EIdAjqmcHMIDatr0w24OM-SoF3cvZcfPTBU"
					target="_blank">Read more</a
				>
			</div>
		</div>
	</div>
{/if}
